import _ from 'lodash';
const planData = [{
  name: 'credit_only_test_set_4',
  heading: 'Build credit with debit',
  title: 'Credit Building',
  description: 'Build credit without earning reward points',
  features: ['Build your credit history automatically with your Extra Debit purchases', 'Gain full understanding of your credit score with the intuitive Extra Credit Monitoring tool', 'Prevent overdafts and add an extra layer of financial security to your bank account with Spend Power'],
  price: [20, 149],
  displayOnlyFullPrice: [null, 240],
  icon: '/plan-credit.svg',
  mobile: {
    title: 'Extra Credit Building',
    features: [0, 1]
  }
}, {
  name: 'combined_test_set_4',
  heading: 'The ultimate extra experience',
  title: 'Credit Building + Rewards',
  description: 'Earn reward points for every swipe and get access to our exclusive reward store',
  features: ['Access to all perks of Extra Credit Building including monthly spend reporting and intuitive score monitoring', 'Access to all perks of Extra Rewards including unlimited points earning and access to the members-only Extra Shops', 'Prevent overdafts and add an extra layer of financial security to your bank account with Spend Power'],
  price: [25, 199],
  displayOnlyFullPrice: [null, 300],
  icon: '/plan-combined.svg',
  mobile: {
    title: 'Rewards + Credit Building',
    features: [0, 1, 2, 3]
  },
  most_popular: true
}];
/* example of cohorts */
// const annualOnlyCohort = [
// 	{
// 		name: 'credit_only_test_set_3',
// 		price: [16, 149],
// 		displayOnlyFullPrice: [null, 200],
// 	},
// 	{
// 		name: 'combined_test_set_3',
// 		price: [22, 199],
// 		displayOnlyFullPrice: [null, 265],
// 	},
// ]
// const cohorts = {
// 	'annual-only-price-change': annualOnlyCohort,
// 	'annual-only-force-plan-reset': annualOnlyCohort,
// }

const cohorts = {};
export default function getPlans(cohort = null) {
  let plans = _.cloneDeep(planData);

  if (cohort && cohorts[cohort]) {
    // apply the cohort-specific overrides
    plans = plans.map((plan, index) => Object.assign(plan, cohorts[cohort][index]));
  } // calculate discount percentages


  plans = plans.map(plan => {
    plan.discount = plan.displayOnlyFullPrice.map((fullPrice, index) => {
      const discount = 100 - Math.round(plan.price[index] / fullPrice * 100);
      return Number.isFinite(discount) ? discount : null;
    });
    return plan;
  });
  return plans;
}